import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { STORE_HREF } from "./LandingChoice";
import { trackEvent } from "../../lib/analytics";

const CONSENT_KEY = "stagvault_cookie_consent_v1";

/* Compact fixed choice bar. Shown only once the hero choice has scrolled away and the cookie decision has been made,
   so it never covers the cookie banner. */
export const LandingStickyChoiceBar = ({ lifetimeHref, soldOut, price = 25 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const target = document.getElementById("choose");
    const footer = document.getElementById("choose-again");
    if (!target) return undefined;
    let heroVisible = true;
    let footerVisible = false;
    const consentGiven = () => { try { return Boolean(localStorage.getItem(CONSENT_KEY)); } catch { return true; } };
    const update = () => setShow(!heroVisible && !footerVisible && consentGiven() && window.scrollY > 320);
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.target === target) heroVisible = e.isIntersecting; if (e.target === footer) footerVisible = e.isIntersecting; });
      update();
    }, { threshold: 0.05 });
    obs.observe(target);
    if (footer) obs.observe(footer);
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("storage", update);
    return () => { obs.disconnect(); window.removeEventListener("scroll", update); window.removeEventListener("storage", update); };
  }, []);

  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-white/10 bg-[#030206]/95 backdrop-blur-xl" role="region" aria-label="Quick purchase choices" data-testid="landing-sticky-choice-bar">
      <div className="mx-auto grid max-w-3xl grid-cols-2 gap-2 px-3 py-2 sm:gap-3 sm:px-6">
        <Link to={STORE_HREF} onClick={() => trackEvent("LandingChoiceClick", { choice: "operator_power_prompts_5", placement: "sticky" })} className="inline-flex min-h-12 items-center justify-center border border-zinc-500 bg-zinc-100 px-3 text-center text-[11px] font-black uppercase tracking-[0.12em] text-black transition-colors hover:bg-white sm:text-xs" data-testid="sticky-cta-5">£5 Product</Link>
        <Link to={soldOut ? "/pricing" : lifetimeHref} onClick={() => trackEvent("LandingChoiceClick", { choice: "full_vault_25", placement: "sticky" })} className="inline-flex min-h-12 items-center justify-center bg-amber-300 px-3 text-center text-[11px] font-black uppercase tracking-[0.12em] text-black transition-colors hover:bg-amber-200 sm:text-xs" data-testid="sticky-cta-25">Stag Vault Complete · £{price}</Link>
      </div>
    </div>
  );
};
